<template>
  <header class="PaB-app__header">
    <div class="PaB-app-actions">
      <search-form></search-form>
      <view-controls :isHome="isHome"></view-controls>
    </div>
    <active-filters></active-filters>
    <category-nav></category-nav>
  </header>
</template>

<style lang="scss" scoped>
.PaB-app-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
  position: relative;

  .PaB-app-search-form {
    flex: 1 1 66%;
    // max-width: 700px;
  }

  @media screen and (min-width: 825px) {
    margin-bottom: 32px;

    .PaB-app-search-form {
      max-width: 700px;
    }

    .PaB-view-controls {
      max-width: 280px;
    }
  }
}
</style>

<script>
import SearchForm from '@/components/SearchForm'
import ViewControls from '@/components/ViewControls'
import ActiveFilters from '@/components/ActiveFilters'
import CategoryNav from '@/components/CategoryNav'

export default {
  name: 'AppHeader',
  data () {
    return {
      isHome: false
    }
  },
  components: {
    SearchForm,
    ViewControls,
    ActiveFilters,
    CategoryNav
  },
  created: function () {
    this.isHome = !!this.$route.matched.find(route => route.name === 'home')
  },
  watch: {
    $route (to, from) {
      this.isHome = !!to.matched.find(route => route.name === 'home')
    }
  }
}
</script>
